/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import UCModal from "../../ucmodal";
import Content from "./content";
import { ReactComponent as OverrideTierIcon } from "../../../resources/images/trophy-02.svg";

/* Styles */
import styles from "./styles";

const OverrideDiscountTierModal = ({ showModal, setShowModal, discountData, staticContent, submitCallback }) => {
  const theme = useTheme();
  const classes = styles({ theme });

  const handleSaveModal = async (payload) => {
    submitCallback(payload)
  }

  return (
    <UCModal
      className={classes.overrideDiscountTierModal}
      customStyle={classes.overrideDiscountTierModalWrapper}
      showModal={showModal}
      setShowModal={setShowModal}
      modalIcon={<OverrideTierIcon />}
      modalTitle={<FormattedMessage id="overrideDiscountTierModal.title" />}
      modalDescription={<FormattedMessage id="overrideDiscountTierModal.subtitle" />}
      modalContent={
        <Content
          setShowModal={setShowModal}
          discountData={discountData}
          staticContent={staticContent}
          handleSaveModal={handleSaveModal}
        />
      }
      dataTestId="chooseTierModal"
    />
  );
};

export default OverrideDiscountTierModal;
